import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { RadioButton, RadioGroup } from '@americanexpress/dls-react';

const IncludePets = ({ onPetsChange, roomIndex, value }) => {
  const isChecked = value ? 'yes' : 'no';
  const { formatMessage } = useIntl();
  const handleOnChange = (event) => {
    const shouldIncludePets = event.target.value === 'yes';
    onPetsChange(shouldIncludePets, roomIndex);
  };
  return (
    <>
      <div className="flex flex-row flex-justify-between margin-1-t flex-align-center">
        <p className="label">
          {formatMessage({ id: 'pets' })}
        </p>
        <RadioGroup
          value={isChecked}
          legend={formatMessage({ id: 'pets' })}
          orientation="horizontal"
          isLegendVisuallyHidden={true}
          data-testid={`room-${roomIndex}-pets-radio-element`}
          defaultValue="no"
          onChange={handleOnChange}
        >
          <RadioButton
            data-testid="no"
            className="pad-1-r"
            id={`room-${roomIndex}-radio-1`}
            label={formatMessage({ id: 'no' })}
            value="no"
          />
          <RadioButton
            data-testid="yes"
            className="pad-1-r"
            id={`room-${roomIndex}-radio-2`}
            label={formatMessage({ id: 'yes' })}
            value="yes"
          />
        </RadioGroup>
      </div>
      <p className="margin-b">{formatMessage({ id: 'pet_info' })}</p>
    </>
  );
};

IncludePets.defaultProps = {
  onPetsChange: null,
  value: false,
};

IncludePets.propTypes = {
  onPetsChange: PropTypes.func,
  roomIndex: PropTypes.number,
  // eslint-disable-next-line react/boolean-prop-naming -- Invalid Bool Name
  value: PropTypes.bool,
};

export { IncludePets as TestableIncludePets };

export default IncludePets;
